import { render } from "./rightBox.vue?vue&type=template&id=713ed244&scoped=true"
import script from "./rightBox.vue?vue&type=script&lang=js"
export * from "./rightBox.vue?vue&type=script&lang=js"

import "./rightBox.vue?vue&type=style&index=0&id=713ed244&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-713ed244"]])

export default __exports__